//供应商结构和关注结构基本相同，只是接口不一样，关注多了一个关注接口
import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 获取供应商列表
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/getSupplierList`, params),
    // 获取关注列表
    gets: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/getFollowList`, params),
    //关注和取关
    follow: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/changeFollow`, params),
}